import { css, styled } from '@mui/material';

export const StyledFooterContainer = styled('footer')(
  ({ theme }) => css`
    background-color: ${theme.palette.background.footer};
    flex-shrink: 0;
    padding: ${theme.spacing('3XL')} ${theme.spacing('LARGE')};
  `
);

export const StyledFooterWrapper = styled('div')(
  ({ theme }) => css`
    margin: 0 auto;
    max-width: ${theme.shape.headerMaxWidth};
  `
);

export const StyledFooterLinksWrapper = styled('ul')(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    row-gap: ${theme.spacing('1XL')};
    padding: 0;
    margin: 0;
    list-style-type: none;

    & > li {
      align-items: center;
      display: flex;

      & > a,
      & > button {
        color: ${theme.palette.text.footerLink};
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }

        &:active {
          color: ${theme.palette.main.product_blue};
        }
      }

      &:not(:last-of-type) {
        margin-right: ${theme.spacing('LARGE')};
      }

      &:not(:last-of-type)::after {
        background-color: ${theme.palette.text.footerLink};
        border-radius: 2px;
        content: '';
        margin-left: ${theme.spacing('LARGE')};
        height: ${theme.spacing('LARGE')};
        width: 0.125rem;
      }
    }
  `
);

export const StyledFooterCopyright = styled('div')(
  ({ theme }) => css`
    color: ${theme.palette.text.copyright};
    margin-top: ${theme.spacing('3XL')};

    ${theme.breakpoints.up('desktop')} {
      margin-top: ${theme.spacing('1XL')};
    }
  `
);

export const StyledBranchName = styled('div')(
  ({ theme }) => css`
    color: ${theme.palette.gray.gray};
    margin-top: ${theme.spacing('LARGE')};
    text-align: right;
  `
);
